<template>
  <div class="account">
    <NavBar />
    <div class="card">
      <van-cell title="Avatar" is-link @click="showAvatarSheet = true">
        <template #default>
          <div class="value-right">
            <van-image
              v-if="user.avatarUrl"
              :src="user.avatarUrl"
              round
              width="1.5rem"
              height="1.5rem"
            />
            <div v-else class="avatar-placeholder" />
          </div>
        </template>
      </van-cell>
      <van-cell title="Nickname" :value="user.nickName || 'Not set'" is-link @click="openNicknameDialog" />
      <van-cell title="Phone" :value="formatMobile(user.mobile)" />
      <van-cell title="Email" :value="user.email || 'Not linked'" is-link @click="openEmailDialog" />
      <van-cell title="Change Password" is-link @click="openPasswordDialog" />
    </div>
    <div class="logout-wrapper">
      <button class="logout-btn" @click="handleLogout">Log out</button>
    </div>
    <!-- Avatar选择弹窗 -->
    <van-action-sheet
      v-model="showAvatarSheet"
      :actions="avatarActions"
      cancel-text="Cancel"
      @select="onAvatarSelect"
    />
    <input
      ref="fileInput"
      type="file"
      accept="image/*"
      style="display: none"
      @change="onFileChange"
    />
    <input
      ref="cameraInput"
      type="file"
      accept="image/*"
      capture="environment"
      style="display: none"
      @change="onFileChange"
    />
    <!-- Edit Nickname弹窗 -->
    <van-dialog
      v-model="showNicknameDialog"
      title="Edit Nickname"
      show-cancel-button
      :show-confirm-button="false"
      :close-on-click-overlay="true"
    >
      <div class="dialog-content">
        <input
          v-model="nicknameInput"
          class="dialog-input"
          placeholder="Please enter nickname"
        />
        <button class="dialog-btn" @click="submitNickname">Confirm</button>
      </div>
    </van-dialog>
    <!-- Edit Email弹窗 -->
    <van-dialog
      v-model="showEmailDialog"
      title="Edit Email"
      show-cancel-button
      :show-confirm-button="false"
      :close-on-click-overlay="true"
    >
      <div class="dialog-content">
        <input
          v-model="emailInput"
          class="dialog-input"
          placeholder="Please enter email"
        />
        <button class="dialog-btn" @click="submitEmail">Confirm</button>
      </div>
    </van-dialog>
    <!-- 修改密码弹窗 -->
    <van-dialog
      v-model="showPasswordDialog"
      title="Change Password"
      show-cancel-button
      :show-confirm-button="false"
      :close-on-click-overlay="true"
    >
      <div class="dialog-content">
        <div class="password-row">
          <input
            v-model="passwordForm.oldPassword"
            class="dialog-input has-eye"
            :type="pwdVisible.old ? 'text' : 'password'"
            placeholder="Please enter current password"
          />
          <van-icon
            class="eye-icon"
            :name="pwdVisible.old ? 'eye-o' : 'closed-eye'"
            @click.stop="togglePwdVisible('old')"
          />
        </div>
        <div class="password-row">
          <input
            v-model="passwordForm.password"
            class="dialog-input has-eye"
            :type="pwdVisible.password ? 'text' : 'password'"
            placeholder="Please enter new password"
          />
          <van-icon
            class="eye-icon"
            :name="pwdVisible.password ? 'eye-o' : 'closed-eye'"
            @click.stop="togglePwdVisible('password')"
          />
        </div>
        <div class="password-row">
          <input
            v-model="passwordForm.confirm"
            class="dialog-input has-eye"
            :type="pwdVisible.confirm ? 'text' : 'password'"
            placeholder="Confirm new password"
          />
          <van-icon
            class="eye-icon"
            :name="pwdVisible.confirm ? 'eye-o' : 'closed-eye'"
            @click.stop="togglePwdVisible('confirm')"
          />
        </div>
        <button class="dialog-btn" @click="submitPassword">Confirm</button>
      </div>
    </van-dialog>
  </div>
</template>
<script>
import NavBar from '@/components/NavBar/index.vue'
import { getUserDetail, uploadFile, updateUserInfo, editPassword } from '@/api'
import myMixin from '@/utils/myMixin'
export default {
  name: 'AccountSetting',
  components: { NavBar },
  mixins: [myMixin],
  data() {
    return {
      user: {},
      showAvatarSheet: false,
      avatarActions: [
        { name: 'Take Photo', value: 'camera' },
        { name: 'Choose from Album', value: 'album' }
      ],
      // Nickname弹窗
      showNicknameDialog: false,
      nicknameInput: '',
      // Email弹窗
      showEmailDialog: false,
      emailInput: '',
      // 密码弹窗
      showPasswordDialog: false,
      passwordForm: {
        oldPassword: '',
        password: '',
        confirm: ''
      },
      pwdVisible: {
        old: false,
        password: false,
        confirm: false
      }
    }
  },
  created() {
    this.fetchDetail()
  },
  beforeDestroy() {
  },
  methods: {
    go(path, query = {}) {
      this.$router.push({ path, query }).catch(() => {})
    },
    async fetchDetail() {
      try {
        const res = await getUserDetail()
        if (res && res.code === 1 && res.data && res.data.userInfo) {
          this.user = res.data.userInfo
        }
      } catch (e) {
        // 已有全局 Toast 拦截
      }
    },
    formatMobile(m) {
      if (!m) return 'Not linked'
      const s = String(m).replace(/\D/g, '')
      if (s.length >= 11) {
        return `${s.slice(0,3)} ${s.slice(3,7)} ${s.slice(7,11)}`
      }
      return m
    },
    handleLogout() {
      localStorage.removeItem('token')
      localStorage.removeItem('userInfo')
      this.$router.replace('/login')
    },
    onAvatarSelect(action) {
      this.showAvatarSheet = false
      if (action.value === 'camera') {
        this.$refs.cameraInput.click()
      } else {
        this.$refs.fileInput.click()
      }
    },
    async onFileChange(e) {
      const file = e.target.files[0]
      if (!file) return
      try {
        this.$toast.loading({ message: 'Uploading...', forbidClick: true })
        const formData = new FormData()
        formData.append('iFile', file)
        const uploadRes = await uploadFile(formData)
        if (uploadRes && uploadRes.code === 1 && uploadRes.data) {
          const avatarUrl = this.getUrl(uploadRes.data.file_path)
          if (avatarUrl) {
            const updateRes = await updateUserInfo({
              avatarUrl,
              nickName: this.user.nickName || '',
              email: this.user.email || ''
            })
            if (updateRes && updateRes.code === 1) {
              this.user.avatarUrl = avatarUrl
              this.$toast.success('Avatar updated')
            } else {
              this.$toast.fail(updateRes.msg || 'Update failed')
            }
          } else {
            this.$toast.fail('Failed to get image URL')
          }
        } else {
          this.$toast.fail(uploadRes.msg || 'Upload failed')
        }
      } catch (err) {
        console.error('Upload error:', err)
        this.$toast.fail('Upload failed')
      }
      e.target.value = ''
    },
    // Nickname弹窗
    openNicknameDialog() {
      this.nicknameInput = this.user.nickName || ''
      this.showNicknameDialog = true
    },
    async submitNickname() {
      if (!this.nicknameInput.trim()) {
        this.$toast('Please enter nickname')
        return
      }
      try {
        this.$toast.loading({ message: 'Submitting...', forbidClick: true })
        const res = await updateUserInfo({
          nickName: this.nicknameInput,
          email: this.user.email || '',
          avatarUrl: this.user.avatarUrl || ''
        })
        if (res && res.code === 1) {
          this.user.nickName = this.nicknameInput
          this.showNicknameDialog = false
          this.$toast.success('Updated successfully')
        } else {
          this.$toast.fail(res.msg || 'Update failed')
        }
      } catch (err) {
        this.$toast.fail('Update failed')
      }
    },
    // Email弹窗
    openEmailDialog() {
      this.emailInput = this.user.email || ''
      this.showEmailDialog = true
    },
    async submitEmail() {
      if (!this.emailInput.trim()) {
        this.$toast('Please enter email')
        return
      }
      try {
        this.$toast.loading({ message: 'Submitting...', forbidClick: true })
        const res = await updateUserInfo({
          email: this.emailInput,
          nickName: this.user.nickName || '',
          avatarUrl: this.user.avatarUrl || ''
        })
        if (res && res.code === 1) {
          this.user.email = this.emailInput
          this.showEmailDialog = false
          this.$toast.success('Updated successfully')
        } else {
          this.$toast.fail(res.msg || 'Update failed')
        }
      } catch (err) {
        this.$toast.fail('Update failed')
      }
    },
    // 密码弹窗
    openPasswordDialog() {
      this.passwordForm = {
        oldPassword: '',
        password: '',
        confirm: ''
      }
      this.pwdVisible = { old: false, password: false, confirm: false }
      this.showPasswordDialog = true
    },
    togglePwdVisible(key) {
      if (!this.pwdVisible || typeof this.pwdVisible[key] === 'undefined') return
      this.pwdVisible[key] = !this.pwdVisible[key]
    },
    async submitPassword() {
      if (!this.passwordForm.oldPassword) {
        this.$toast('Please enter current password')
        return
      }
      if (!this.passwordForm.password) {
        this.$toast('Please enter new password')
        return
      }
      if (this.passwordForm.password !== this.passwordForm.confirm) {
        this.$toast('Passwords do not match')
        return
      }
      try {
        this.$toast.loading({ message: 'Submitting...', forbidClick: true })
        const res = await editPassword({
          old_password: this.passwordForm.oldPassword,
          password: this.passwordForm.password,
          confirm_password: this.passwordForm.confirm
        })
        if (res && res.code === 1) {
          this.showPasswordDialog = false
          this.$toast.success('Updated successfully')
        } else {
          this.$toast.fail(res.msg || 'Update failed')
        }
      } catch (err) {
        this.$toast.fail('Update failed')
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.account {
  min-height: 100vh;
  background: #f5f7fa;
}
.card {
  margin: 0.75rem;
  background: #fff;
  border-radius: 0.5rem;
  overflow: hidden;
}
.value-right {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-end;
}
.avatar-placeholder {
  width: 1.5rem;
  height: 1.5rem;
  border-radius: 50%;
  background: #d8d8d8;
}
.logout-wrapper {
  display: flex;
  justify-content: center;
  margin-top: 2rem;
  padding: 0 0.75rem;
}
.logout-btn {
  padding: 0.5rem 1.5rem;
  background: #fff;
  border: 1px solid #e5e5e5;
  border-radius: 0.25rem;
  font-size: 0.875rem;
  color: #333;
  cursor: pointer;
}
.dialog-content {
  padding: 1rem;
}
.dialog-input {
  width: 100%;
  height: 2.5rem;
  padding: 0 0.75rem;
  border: 1px solid #e5e5e5;
  border-radius: 0.25rem;
  font-size: 0.875rem;
  box-sizing: border-box;
  margin-bottom: 0.75rem;
  outline: none;
}
.dialog-input.has-eye{
  padding-right: 2.5rem;
}
.password-row{
  position: relative;
}
.eye-icon{
  position: absolute;
  right: 0.75rem;
  top: 50%;
  transform: translateY(-50%);
  color: #999;
  font-size: 18px;
  cursor: pointer;
}
.dialog-input:focus {
  border-color: #1E3C3E;
}
.dialog-btn {
  width: 100%;
  height: 2.5rem;
  background: #1E3C3E;
  color: #fff;
  border: none;
  border-radius: 0.25rem;
  font-size: 0.875rem;
  cursor: pointer;
  margin-top: 0.5rem;
}
</style>
